import React from 'react';
import { Link } from 'react-router-dom';
import './News.css';
import OpeningImage from '../assets/img/opening.webp';
import EarlyBirdImage from '../assets/img/early-bird.webp';
import VouchersImage from '../assets/img/vouchers.webp';
import HaekelTreffImage from '../assets/img/haekel-treff-winter.webp';
import KuerbisSchnitzenImage from '../assets/img/event-kuerbis-schnitzen.webp';
import { Seo, buildBreadcrumbSchema } from '../components/Seo';

const newsItems = [
    {
        id: 11,
        title: 'Kürbis schnitzen',
        date: 'Mittwoch, 28. Oktober 2026, 14:00 - 16:30 Uhr',
        tag: 'Event',
        image: KuerbisSchnitzenImage,
        imageAlt: 'Kürbis schnitzen im Sarita’s: ein lachender Kürbis mit Hexenhut',
        imageClassName: 'news-card__image--poster',
        description: 'Für Kinder in Begleitung eines Erwachsenen und erwachsene Kinder. CHF 25.- inklusive Kürbis, Hauseistee und hausgemachten Brownies. Schnitzwerkzeug und Arbeitsfläche stehen bereit. Anmeldung bis Montag, 26. Oktober per Mail oder Telefon.',
        link: '/kuerbis-schnitzen',
        linkLabel: 'Details und Anmeldung'
    },
    {
        id: 10,
        title: 'Kaffee, Kuchen und Häkeln',
        date: 'Samstag, 21. November 2026, 11:00 - 16:30 Uhr',
        tag: 'Event',
        image: HaekelTreffImage,
        imageAlt: 'Winterliches Motiv zum weihnachtlichen Häkel-Treff',
        description: "Bring deine eigene Häkel- oder Strickarbeit mit. Für Anfänger:innen gibt es Weihnachts-Startersets inklusive Material für CHF 15.- bis 25.-. Sarah hilft bei Fragen und bietet Anleitungen für verschiedene Weihnachtssujets.",
        link: '/haekel-treff',
        linkLabel: 'Details und Anmeldung'
    },
{
        id: 9,
        title: 'Neu: Geschenkgutscheine',
        date: 'Ab sofort',
        tag: 'Angebot',
        image: VouchersImage,
        imageAlt: "Geschenkgutschein f\u00fcr Sarita's mit Kaffee und Geschenk",
        description: "Verschenken Sie eine genussvolle Zeit bei Sarita's. Den Wert des Geschenkgutscheins bestimmen Sie selbst. Unsere Geschenkgutscheine sind ab sofort direkt bei uns an der Kasse erh\u00e4ltlich."
    },
    {
        id: 4,
        title: 'Neu: Early-Bird Angebote',
        date: 'Ab sofort, 6.30 - 7.30 Uhr',
        tag: 'Angebot',
        image: EarlyBirdImage,
        imageAlt: 'Illustration der Early-Bird Angebote mit Vogel, Sonnenaufgang, Kaffee und Gipfeli',
        description: (
            <>
                Starte den Morgen bei Sarita&apos;s mit zwei neuen Early-Bird Angeboten: Kaffee oder Espresso mit
                Gipfeli f&uuml;r CHF 5.- oder Kaffee oder Espresso mit Muffin, Zimtschnecke oder Nussecke f&uuml;r CHF 6.90.
            </>
        )
    },
    {
        id: 1,
        title: 'Danke f\u00fcr die sch\u00f6ne Neuer\u00f6ffnung',
        date: '11.04.2026',
        tag: 'R\u00fcckblick',
        image: OpeningImage,
        imageAlt: "Neuer\u00f6ffnung von Sarita's am Bahnhofplatz 1 in Hinwil",
        description: "Vielen Dank f\u00fcr die vielen Besuche und die herzliche Unterst\u00fctzung zur Neuer\u00f6ffnung von Sarita's am Bahnhofplatz 1 in Hinwil. Wir freuen uns, Sie weiterhin bei Kaffee, Cheesecake, Lunch und Brunch begr\u00fcssen zu d\u00fcrfen."
    },
];

function News() {
    return (
        <div className='news-page'>
            <Seo
                title='Aktuell'
                description='Neuigkeiten, Hinweise und aktuelle Angebote von Sarita&apos;s in Hinwil.'
                path='/news'
                schema={[
                    buildBreadcrumbSchema([
                        { name: 'Startseite', path: '/' },
                        { name: 'Aktuell', path: '/news' }
                    ])
                ]}
            />
            <header className='page-hero news-hero'>
                <div className='container page-hero__content'>
                    <h1 className='page-hero__title'>Aktuell</h1>
                </div>
            </header>

            <section className='section-shell'>
                <div className='container'>
                    <div className='news-intro'>
                        <p className='section-eyebrow text-center'>Was läuft gerade</p>
                        <h2 className='section-title text-center'>Neuigkeiten von Sarita&apos;s</h2>
                    </div>
                    <div className='news-grid'>
                    {newsItems.map((item) => (
                        <article className='news-card panel-surface reveal' key={item.id}>
                            {item.image ? (
                                <img className={`news-card__image ${item.imageClassName || ''}`} src={item.image} alt={item.imageAlt} />
                            ) : null}
                            <div className='news-card__body'>
                                <p className='news-card__tag'>{item.tag}</p>
                                <p className='news-card__date'>{item.date}</p>
                                <h3>{item.title}</h3>
                                <p>{item.description}</p>
                                {item.link ? (
                                    <Link to={item.link} className='news-card__link'>
                                        {item.linkLabel}
                                    </Link>
                                ) : null}
                            </div>
                        </article>
                    ))}
                    </div>
                </div>
            </section>
        </div>
    );
}

export default News;
